// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ProductBlok_wrap__vgX0n","inner":"ProductBlok_inner__RK4x9"};